import React, { Component } from 'react';
import LogErrorService from '../../services/log-error-service';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  async componentDidCatch(error, info) {
    this.setState({ hasError: true });
    await LogErrorService.sentToSlack({ error, info });
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    return hasError ? (
      <h1>Ha pasado una incidencia, por favor, comunicarse con soporte@23people.io</h1>
    ) : (
      children
    );
  }
}

export default ErrorBoundary;
